import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
import { ReactComponent as EyeSlashIcon } from '../../assets/icons/eye-slash.svg';
import { resetPassword } from '../../utils/backend';
import AnsaLogo from '../../assets/images/ansa/ansa-logo.svg';
import { cilLockLocked } from '@coreui/icons';
import { toast } from 'react-toastify';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      setLoading(false);
      return;
    }
    try {
      const payload = {
        token: token,
        password: password,
        confirm_password: confirmPassword,
      };
      const response = await resetPassword(payload);

      if (response.success) {
        toast.success(response.message);
        navigate('/login');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error('Password reset failed', error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <img src={AnsaLogo} alt="Ansa Logo" />
      </div>
      <div className="login-right">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol md={8}>
              <CCard className="p-4 border-light">
                <CCardBody>
                  <CForm onSubmit={handleReset}>
                    <h2>Reset Password</h2>
                    <p className="text-body-secondary">An email has been sent with instructions to reset your password</p>
                    {loading ? (
                      <div className="text-center">
                        <CSpinner color="primary" />
                      </div>
                    ) : (
                      <>

                        <CRow>

                          <CCol xs={6} className="text-right">
                            <Link to="/login">
                              <CButton type="button" className="ansa-button-primary px-4" onClick={() => navigate('/login')}>
                                Back to Login
                              </CButton>
                            </Link>
                          </CCol>
                        </CRow>
                      </>
                    )}
                  </CForm>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </div>
  );
};

export default ResetPassword;